<template>
    <div style="width: 100%">
        <div v-if="useMDP193Implementation" class="as-a-coach-page">
            <div class="as-a-coach-page-header">
                <AsACoachHeader />
            </div>
            <AsACoachMenu :yourEmployeesToCoachAndInspectCount="employeeCount" />
            <YourEmployeesToInspectTab ref="employeesTab" />
        </div>

        <AsCoach 
            v-else 
            :guideData="guideData"
            @guide-close="handleGuideClose"
        />
    </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import AsACoachHeader from '@components/AsACoachHeader/AsACoachHeader.vue';
import AsACoachMenu from '@components/AsACoachMenu/AsACoachMenu.vue';
import YourEmployeesToInspectTab from '@components/AsACoachTab/AsACoachTab.vue';
import AsCoach from '../../account/src/views/AsCoach.vue';
import Knock, { KnockGuideClient } from "@knocklabs/client";
import configService from "../../account/src/services/config";

const props = defineProps({
    yourEmployeesToCoachAndInspectCount: {
        type: Number,
        default: 0,
    },
    forceMDP193: {
        type: Boolean,
        default: undefined,
    },
    mockGuideData: {
        type: Object,
        default: null,
    },
});

const instance = getCurrentInstance();
const { proxy } = instance;

const employeesTab = ref(null);
const guideData = ref(null);
const knockClient = ref(null);
const guideClient = ref(null);
const guides = ref([]);

const displayGuideData = computed(() => {
    // Use mock data if provided (for Storybook), otherwise use real Knock data
    return props.mockGuideData || guideData.value;
});

const useMDP193Implementation = computed(() => {
    // Allow forcing the implementation via prop (useful for Storybook)
    if (props.forceMDP193 !== undefined) {
        return props.forceMDP193;
    }
    return proxy.flags?.['MDP-193'] || false;
});

const employeeCount = computed(() => {
    return employeesTab.value?.totalCount || 0;
});

const initializeKnock = async () => {
    try {
        const authUser = JSON.parse(localStorage.getItem("user"));
        const apiKey = configService.get("knockApiKey");
        const userId = authUser?.id?.toString();
        const channelId = configService.get("knockGuideChannelId");


        knockClient.value = new Knock(apiKey);
        knockClient.value.authenticate({ id: userId });

        guideClient.value = new KnockGuideClient(knockClient.value, channelId);

        guideClient.value.store.subscribe(() => {
            const storeState = guideClient.value.store.state;
            guides.value = guideClient.value.selectGuides(storeState) || [];
            const coachGuide = guides.value.find(
                (guide) => guide.key === "what-is-a-coach"
            );
            guideData.value = coachGuide?.steps?.[0] || null;
        });

        await guideClient.value.subscribe();
        await guideClient.value.fetch();
    } catch (error) {
        console.error("❌ Error initializing Knock:", error);
    }
};

const handleGuideClose = () => {
    // Handle guide close if needed
};

onMounted(async () => {
    try {
        await proxy.$watchFlag('MDP-193', false);
        await initializeKnock();
    } catch (error) {
        console.error('Error loading MDP-193 feature flag:', error);
    }
});

defineExpose({
    employeesTab,
});
</script>

<style scoped>
.as-a-coach-page {
    margin: 20px;
}

.as-a-coach-page-header { 
    margin-bottom: 16px;
}
</style>